import { HsaKnockoutStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import XCircleIcon from "@redotech/redo-icons/x-circle.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface HsaKnockoutNodeData {
  step: PartialWithRequiredType<HsaKnockoutStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const HsaKnockoutNode = memo(function HsaKnockoutNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: HsaKnockoutNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return (
    <BaseNode
      icon={<RedoFeaturedIcon color="error" Icon={XCircleIcon} size="sm" />}
      onDelete={data.readonly ? undefined : () => data.deleteElements(id)}
      selected={selected}
      step={data.step}
      title={t("Knockout")}
    >
      <Handle id="top" position={Position.Top} type="target" />
      <Flex className={NodeCSS.fullWidth} dir="column" gap="xs">
        <Text fontSize="xxs" textColor="secondary">
          {t("Reason")}
        </Text>
        {data.step.reason ? (
          <Flex w="full">
            <RedoBadge color="error" size="xs" text={data.step.reason} />
          </Flex>
        ) : (
          <Text className={NodeCSS.placeholderText}>{t("No reason")}</Text>
        )}
      </Flex>
    </BaseNode>
  );
});
